import { useCallback, useEffect, useState } from "react";

import { I18nContext, I18nLocale } from "./context";
import { translate } from "./helpers";

import type { ReactNode } from "react";
import type { I18nDict, I18nEntryOptions } from "./context";

export function I18nProvider({
  children,
  dict = {},
  locale = I18nLocale.EN,
}: {
  children: ReactNode;
  dict?: I18nDict;
  locale?: I18nLocale;
}) {
  const [labels, setLabels] = useState<I18nDict>(dict);

  const t = useCallback(
    (
      key: string,
      options?: I18nEntryOptions,
      fallback?: string | Record<string, string>,
    ) => {
      return translate(labels, key, options, fallback);
    },
    [labels],
  );

  useEffect(() => {
    // Gaurd against failed requests erasing the dictionary
    if (Object.entries(dict).length) {
      setLabels(dict);
    }
  }, [dict]);

  const value = {
    dict,
    locale,
    t,
  };

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}
